import { render } from "./FoodMenuEditContainer.vue?vue&type=template&id=0a9a9bec&scoped=true&ts=true"
import script from "./FoodMenuEditContainer.vue?vue&type=script&lang=ts"
export * from "./FoodMenuEditContainer.vue?vue&type=script&lang=ts"

import "./FoodMenuEditContainer.vue?vue&type=style&index=0&id=0a9a9bec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9a9bec"]])

export default __exports__